import { Grid, Typography } from '@mui/material'
import { ComponentCatalogSection } from './ComponentCatalogSection'
import { ComponentCatalogExample } from './ComponentCatalogExample'

const TypographyExample = ComponentCatalogExample

export const TypographySection = () => {
  return (
    <ComponentCatalogSection name="Typography">
      <Grid
        container
        rowSpacing="8px"
        columnSpacing={{
          xs: '24px',
          sm: '24px',
          md: '16px',
          lg: '24px',
          xl: '24px',
        }}
      >
        <TypographyExample name="h1">
          <Typography variant="h1">{quotes.h1}</Typography>
        </TypographyExample>

        <TypographyExample name="h2">
          <Typography variant="h2">{quotes.h2}</Typography>
        </TypographyExample>
        <TypographyExample name="h3">
          <Typography variant="h3">{quotes.h3}</Typography>
        </TypographyExample>

        <TypographyExample name="h4">
          <Typography variant="h4">{quotes.h4}</Typography>
        </TypographyExample>

        <TypographyExample name="body-1">
          <Typography variant="body-1">{quotes['body-1']}</Typography>
        </TypographyExample>

        <TypographyExample name="body-2">
          <Typography variant="body-2">{quotes['body-2']}</Typography>
        </TypographyExample>

        <TypographyExample name="body-3">
          <Typography variant="body-3">{quotes['body-3']}</Typography>
        </TypographyExample>

        <TypographyExample name="subtitle-1">
          <Typography variant="subtitle-1">{quotes['subtitle-1']}</Typography>
        </TypographyExample>

        <TypographyExample name="subtitle-2">
          <Typography variant="subtitle-2">{quotes['subtitle-2']}</Typography>
        </TypographyExample>

        <TypographyExample name="label-form">
          <Typography variant="label-form">{quotes['label-form']}</Typography>
        </TypographyExample>

        <TypographyExample name="label-CTA">
          <Typography variant="label-CTA">{quotes['label-CTA']}</Typography>
        </TypographyExample>
      </Grid>
    </ComponentCatalogSection>
  )
}

const quotes = {
  h1: "If I don't have red, I use blue",
  h2: 'Everything you can imagine is real.',
  h3: 'Art washes away from the soul the dust of life.',
  h4: "Go and do the things you can't. That is how you get to do them.",
  'body-1':
    'There is only one difference between a madman and me. The madman thinks he is sane. I know I am mad.',
  'body-2':
    'Great wine requires a mad man to grow the vine, a wise man to watch over it, a lucid poet to make it, and a lover to drink it.',
  'body-3':
    'The difference between false memories and true ones is the same as for jewels: it is always the false ones that look the most real, the most brilliant.',

  'subtitle-1':
    'If you refuse to study anatomy, the arts of drawing and perspective, the mathematics of aesthetics, and the science of color, let me tell you that this is more a sign of laziness than of genius.',
  'subtitle-2':
    'The secret of my influence has always been that it remained secret.',
  'label-form':
    'You have to systematically create confusion, it sets creativity free. Everything that is contradictory creates life.',
  'label-CTA': 'Those who do not want to imitate anything, produce nothing.',
}
